<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <label for="" class="mb-0"><b>Progreso:</b> {{ record.progressPercentage }}%</label>
      <div class="progress mb-0">
          <div class="progress-bar" role="progressbar" :aria-valuenow="record.progressPercentage" aria-valuemin="0" aria-valuemax="100" :style="{ width: record.progressPercentage + '%' }">{{record.progressPercentage}}%</div>
      </div>
      <div><span><b>Código:</b> {{ record.code }}</span></div>
      <div><span><b>Curso:</b> {{ record.coursename }}</span></div>
      <div><span><b>Estudiante:</b> {{ record.username }}</span></div>
      <div><span><b>Fecha Inicio:</b> {{ record.startDate }}</span></div>
      <div><span><b>Fecha Fin:</b> {{ record.endDate }}</span></div>
      <div><span><b>Estado:</b> {{ record.status === 1 ? 'Activo' : 'Inactivo' }}</span></div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
        </div>
    </b-modal>
  </div>
</template>

<script>

import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
      dataRecord: [],
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
      // this.$emit('getRecords');
      // bvModalEvent.preventDefault()
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>